import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Arbitrator from '../../components/Arbitrator';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import UploadedDoc from '../../components/UploadedDoc';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import UploadDocs from '../Onboarding/UploadDocs';
import leftIcon from '../../images/left.png'
import PropTypes from "prop-types";

const styles = theme => ({
    root: {
        //width: '100%',
        height: '100%', /* Magic here */
        //marginLeft:'28%'

        //margin: '0 auto',
    },
    uploadDocs:{
        marginTop:'20px'
        //margin: '0 auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    margin : {
        marginTop:'40px',
        fontWeight: 'bold'
    },
});

class DocsListForOnBoarding extends Component {
    state = {
      totaluploadFiles: 1,
      currentUser: '',
      typeOfAccount:localStorage.getItem('typeOfAccount')
    };

    componentWillMount(){
        // console.log('DocsListForOnBoarding window.location.href '+window.location.href)
        
        // var path = window.location.href;
        // var sPath = path.split('/');
        // console.log('path split: '+sPath[sPath.length-1]);
        // if(sPath[sPath.length-1] == 'claimantsDocument'){
        //     console.log('pathis claimant');
        //     this.setState({
        //         currentUser: 'claimant'
        //     })
        // }
        // if(sPath[sPath.length-1] == 'respondentsDocument'){
        //     console.log('pathis respondent');
        //     this.setState({
        //         currentUser: 'respondent'
        //     })
        // } 

        
    }

    componentDidMount(){
        // this.props.getCaseInfo(this.props.caseId, localStorage.getItem('token'));
        // console.log('doclsit currentUser: '+this.state.currentUser);
        // console.log('doclsot userType: '+this.props.userType);
        this.checkLanguage()
        
    }

    checkLanguage = function() {
        try{
        //   if (this.props.isLoading){
        //     setTimeout(()=>{this.checkLanguage()},100)
        //   }
        //   else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
        //   }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }

    handleChange = event => {
        this.setState({value: event.target.value});
        //this.props.setArbitrator(event.target.value);
    }

    handleOnAddIcon = () => {
        this.setState((state) => ({totaluploadFiles: state.totaluploadFiles + 1}))
    }

    handleAddFile = (file, doc_name) => {
        this.props.addFile(file, doc_name);
    }

    handleResetFile = (filename) => {
        this.props.removeFile(filename);
    }

    submitHandler = (event) => {
        event.preventDefault();
        //this.props.onSetRedirectPath('/home');
        //this.setState({loginInProgress: true,})
        this.props.uploadDocs(this.props.files);
        //this.props.history.push(this.props.authRedirect);    
    };

    render(){
        const { classes } = this.props;
        var disableUploadDoc = false
        // if (this.props.caseData.startDateForFurtherProceedings !== undefined){
        //     var now = new Date();
        //     var startProceeding = new Date(this.props.caseData.startDateForFurtherProceedings)

        //     var responseTimestampFourDaysLater = new Date(this.props.caseData.startDateForFurtherProceedings)
        //     responseTimestampFourDaysLater.setDate(responseTimestampFourDaysLater.getDate() + 4);

        //     var responseTimestampDateToSubmitDocuments = new Date(this.props.caseData.startDateForFurtherProceedings)
        //     responseTimestampDateToSubmitDocuments.setDate(responseTimestampDateToSubmitDocuments.getDate() + 7);
            
        //     var responseTimestampCompleteSubmissionInterrogatoryAndEnquiry = new Date(this.props.caseData.startDateForFurtherProceedings)
        //     responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.setDate(responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getDate() + 11);

        //     var responseTimestampToAward = new Date(this.props.caseData.startDateForFurtherProceedings)
        //     responseTimestampToAward.setDate(responseTimestampToAward.getDate() + 18);
            
        //     if (now >= responseTimestampDateToSubmitDocuments){
        //         disableUploadDoc = true
        //     }
        // }

        return(
            <div className={classes.root}>
                {/* <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button> */}
                {
                    this.props.userType == 'claimant' &&
                    <Typography variant="h5" className={classes.margin} gutterBottom>
                        {this.context.t("Claimant's Documents")}:
                    </Typography> &&
                    <div className={classes.uploadDocs}>
                        <UploadedDoc  
                            rows={this.props.docs.claimant_docs} 
                            caseId={this.props.caseId}
                            docType="claimant"
                        />
                    </div>
                }
                
                <div></div>

                {
                    this.props.userType == 'respondent' &&
                    <Typography variant="h5" className={classes.margin} gutterBottom>
                        {this.context.t("Respondent's Documents")}:
                    </Typography> &&
                    <div className={classes.uploadDocs}>
                        <UploadedDoc  
                            rows={this.props.docs.respondent_docs} 
                            caseId={this.props.caseId}
                            docType="respondent"
                        />
                    </div>
                }
                
                {/* { (this.state.typeOfAccount !== 'arbitrator') && disableUploadDoc == false &&
                    <Typography variant="h5" className={classes.margin} gutterBottom>
                        {this.context.t("Upload New Files")}:
                    </Typography> }
                { (this.state.typeOfAccount !== 'arbitrator') && disableUploadDoc == false &&
                    <div className={classes.uploadDocs}>
                        <UploadDocs />
                    </div>
                } */}

                {/*(this.props.showUploadDocs && 
                   <Typography variant="subtitle1" className={classes.subText} gutterBottom>
                        Upload New Files:
                    </Typography>
                )*/} 
                {/*(this.props.showUploadDocs && 
                <div className={classes.uploadDocs}>
                    <UploadDocs />
                    </div>
                )*/} 
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.uploadDocs.loading,
        files: state.uploadDocs.files,
        userType: state.caseInfo.userType,
        caseId: state.caseInfo.caseId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
        removeFile: (filename) => dispatch(actions.removeFile(filename)),
        uploadDocs : (files) => dispatch(actions.uploadDocs(files)),
    }
}

DocsListForOnBoarding.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DocsListForOnBoarding));
